import styled from 'styled-components';

const SafefarmRespondWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0B2A1B;
  padding: 24px 16px;

  .respondCard {
    width: 100%;
    max-width: 420px;
    background: #ffffff;
    border-radius: 12px;
    padding: 32px 24px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
    text-align: center;
  }

  .respondLogo {
    height: 40px;
    margin-bottom: 16px;
  }

  .respondTitle {
    font-size: 22px;
    font-weight: 600;
    color: #0B2A1B;
    margin-bottom: 4px;
  }

  .respondSubtitle {
    font-size: 14px;
    color: #555;
    margin-bottom: 24px;
  }

  .respondActions {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .respondActions .ant-btn {
    height: 56px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 8px;
  }

  .btnResponding {
    background-color: #1e8e3e;
    border-color: #1e8e3e;
    color: #fff;
    &:hover, &:focus { background-color: #166f31; border-color: #166f31; color: #fff; }
  }

  .btnNotAvailable {
    background-color: #e8a317;
    border-color: #e8a317;
    color: #fff;
    &:hover, &:focus { background-color: #b87d10; border-color: #b87d10; color: #fff; }
  }

  .btnTerminate {
    background-color: #c0392b;
    border-color: #c0392b;
    color: #fff;
    &:hover, &:focus { background-color: #962d22; border-color: #962d22; color: #fff; }
  }

  .respondState {
    padding: 24px 8px;
    color: #333;
  }

  .respondState h2 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .respondState p {
    font-size: 14px;
    color: #555;
    margin: 0;
  }

  .respondFooter {
    margin-top: 24px;
    font-size: 12px;
    color: #888;
  }
`;

export default SafefarmRespondWrapper;
